import type {
  HeatmapScrollQueryResponse,
  HeatmapScrollQueryVariables,
} from '~/modules/heatmap/graphql/queries/heatmapScroll.generated';
import type { BaseHeaderResponse } from '~/api/types/graphqlClient';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { IHeatmapScroll } from '../../types';

import { HeatmapScrollDocument } from '~/modules/heatmap/graphql/queries/heatmapScroll.generated';
import { HEATMAP_QUERY_KEYS } from '../../websocket';
import { useQuery } from '@tanstack/react-query';
import { appFetcherCustom } from '~/api/utils';

export interface CustomHeatmapScrollResponse extends HeatmapScrollQueryResponse {
  heatmapScroll: IHeatmapScroll;
  headers: BaseHeaderResponse;
}

export const useCustomHeatmapScrollQuery = <TData = CustomHeatmapScrollResponse, TError = unknown>(
  variables: HeatmapScrollQueryVariables,
  options?: UseQueryOptions<CustomHeatmapScrollResponse, TError, TData>,
) => {
  return useQuery<CustomHeatmapScrollResponse, TError, TData>(
    [HEATMAP_QUERY_KEYS.scroll, variables],
    appFetcherCustom<CustomHeatmapScrollResponse, HeatmapScrollQueryVariables>(
      HeatmapScrollDocument,
      variables,
    ),
    options,
  );
};

useCustomHeatmapScrollQuery.getKey = (variables?: HeatmapScrollQueryVariables) => [
  HEATMAP_QUERY_KEYS.scroll,
  variables,
];
